import styles from './JobAttributes.module.css'

export default function JobAttributes({data, category}) {
  let categorizedData = {};

  if(!data) return(<div></div>)

  data.forEach(attr => {
    if(!categorizedData[attr.category]) {
      categorizedData[attr.category] = []
    }

    categorizedData[attr.category].push(attr)
  })

  return(
    <JobAttributesContainer attributes={categorizedData}/>
  )
}

function JobAttributesContainer({attributes}) {
  const categories = Object.keys(attributes)
  const attributeRows = categories.map((category, index) => {
    return(<JobAttribute category={category} attributes={attributes[category]} key={category}/>)
  });

  return(
    <div className={styles["attributes-container"]}>
      {attributeRows.length > 0 ? attributeRows : "None found"}
    </div>
  )
}

function JobAttribute({category, attributes}) {
  const buildCategory = (category) => {
    if (category === "undefined") {
      return(<></>)
    } else {
      return(<p className={styles["badge-category"]}>{category}</p>)
    }
  }

  const attributeElements = attributes.map((attribute, index) => {
    return(<span key={attribute.name} className="badge badge-primary">{attribute.name}</span>)
  })

  return(
    <div className={styles["attributes-row"]}>
      {buildCategory(category)}
      {attributeElements}
    </div>
  )
}